var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.elementsLoaded
    ? _c(
        "div",
        { staticClass: "finishedProjects" },
        [
          _vm.elements.length > 0
            ? _c("h2", [_vm._v("Meine beendeten Aktionen")])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.pairedElements, function(pair, index) {
            return [
              _c("div", { staticClass: "doubleTeaser" }, [
                _c("div", [
                  _c("div", { staticClass: "card-deck-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "card-deck" },
                      [
                        _vm._l(pair, function(element, innerIndex) {
                          return [
                            _c("div", {
                              staticClass: "card",
                              domProps: { innerHTML: _vm._s(element.html) }
                            })
                          ]
                        }),
                        _vm._v(" "),
                        pair.length < 2
                          ? _c("div", { staticClass: "card" })
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ])
              ])
            ]
          }),
          _vm._v(" "),
          _vm.hasMoreInternal
            ? _c(
                "button",
                {
                  staticClass: "btn btn-white teaserButton width100",
                  staticStyle: { "margin-top": "30px" },
                  on: { click: _vm.getElements }
                },
                [_vm._v("lade ältere aktionen")]
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c742f26a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c742f26a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyFinishedProjectsList.vue
// module id = 602
// module chunks = 2